import * as Sentry from '@sentry/sveltekit'
import { get } from 'svelte/store'

import { browser } from '$app/environment'
import { useSentryHooks } from '$lib/sentry/sentry_hooks_config.js'
import { account } from '$lib/stores/account/account'

export const sentryMessage = (msg: string, options?: object): string => {
	// init()

	let uId = '' // '<unknown>'
	if (browser) uId = get(account).id

	let opt = options || {}

	opt = { ...opt, user_id: uId }
	msg += '\ninfo: ' + JSON.stringify(opt)

	// Use of sentry needs to have sentry_hooks loaded
	if (useSentryHooks()) {
		Sentry.captureMessage(msg)
	} else {
		console.error('sentryMessage - msg: ', msg)
	}
	console.log('sentryMessage - msg: ', msg)

	return msg
}

export const sentryError = (msg: string, options?: object): Error => {
	// init()

	let uId = '' // '<unknown>'
	if (browser) uId = get(account).id

	let opt = options || {}

	opt = { ...opt, user_id: uId }
	msg += '\ninfo: ' + JSON.stringify(opt)

	const err = new Error(msg)

	// Use of sentry needs to have sentry_hooks loaded
	if (useSentryHooks()) {
		Sentry.captureException(err)
	}
	console.error('sentryError - msg: ', msg)

	return err
}
